import * as React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Button from "../components/Button";
import Typography from "../components/Typography";
import Notes from "./Notes";

function News() {
  return (
    <Box
      component="section"
      sx={{ display: "flex", bgcolor: "secondary.light", overflow: "hidden" }}
    >
      <Container
        sx={{
          mt: 10,
          mb: 10,
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <p id="News" />
        <Typography variant="h4" marked="center" component="h2" sx={{ mb: 5 }}>
          NEWS
        </Typography>
        <Notes />
        <Button
          color="secondary"
          variant="contained"
          component="a"
          href="https://note.com/gakuseiguild"
        >
          Noteへ（外部リンク）
        </Button>
      </Container>
    </Box>
  );
}

export default News;
